// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { profileManager } from "../../../game_theme/flow_fb/flowController";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { tgfComponents } from "../../framework/components/tgfComponents";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfHooks } from "../../framework/hooks/hooks";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { GraphicsSettings } from "../../settings/Settings";
import { AIController } from "../AIController";
import { angrybirds_regular, angrybirds_regular_text } from "../AssetDefinitions/FontDefinitions";
import { s_versus_center, s_scorebar_pink, s_scorebar_blue, s_pigscore, s_pigscore_main, s_ui_pig_green_scared, s_ui_pig_green_default_main, s_portrait_empty, s_profile_placeholder, s_rankbg } from "../AssetDefinitions/ImageDefinitions";
import { ExpManager } from "../ExpManager";
import { playController } from "../gameController";
tgfSettings.dialogDefaults.scoreBarDialog = {
    components: [],
    isInitiatingPlayer: true
};
// The constructor for the component
/**
 * @constructor
 * @base ComponentBase
 */
export var ScoreBarDialog = function (properties) {
    "use strict";
    this.name = "ScoreBarDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.container);
    this.setProperties(tgfSettings.dialogDefaults.powerUpDialog);
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base component
tgfComponents.inherit(ScoreBarDialog, DialogBase);
ScoreBarDialog.prototype.doPrepare = function () {
    var _this = this;
    this.container = new ComponentContainer();
    this.addComponent(this.container);
    var UI_OFFSET_X = GraphicsSettings.hudOffsetX;
    var UI_OFFSET_Y = GraphicsSettings.hudOffsetY;
    var UI_SIZE_X = GraphicsSettings.hudScaleX;
    var UI_SIZE_Y = GraphicsSettings.hudScaleY;
    var topFont = {
        fontFace: angrybirds_regular.fontFace,
        fillColor: "white",
        strokeColor: "black",
        align: "left",
        stroke: false,
        strokeWidth: 0,
        fontSize: 22,
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
    };
    var topFontPigCount = {
        fontFace: angrybirds_regular.fontFace,
        fillColor: "white",
        strokeColor: "black",
        align: "center",
        stroke: true,
        strokeWidth: 5,
        fontSize: 22,
        fontStyle: 'italic',
        padding: 20
    };
    this.vsBadge = new ComponentPicture({
        image: s_versus_center,
        width: 80,
        height: 80,
        xScale: 0.85,
        yScale: 0.85,
        x: (tgfGraphics.areaWidth * 0.5) + UI_OFFSET_X,
        y: 50 + UI_OFFSET_Y
    });
    this.backBarRight = new ComponentPicture({
        image: s_scorebar_pink,
        width: 256,
        height: 48,
        xScale: -1,
        yScale: UI_SIZE_Y,
        x: 220,
        y: 0
    });
    this.vsBadge.addComponent(this.backBarRight);
    this.backBarLeft = new ComponentPicture({
        image: s_scorebar_blue,
        width: 256,
        height: 48,
        xScale: UI_SIZE_X,
        yScale: UI_SIZE_Y,
        x: -220,
        y: 0
    });
    this.vsBadge.addComponent(this.backBarLeft);
    this.redPigBadge = new ComponentPicture({
        image: s_pigscore,
        width: 48,
        height: 48,
        xScale: 1,
        yScale: 1,
        x: 70,
        y: 0
    });
    this.vsBadge.addComponent(this.redPigBadge);
    this.bluPigBadge = new ComponentPicture({
        image: s_pigscore_main,
        width: 48,
        height: 48,
        xScale: 1,
        yScale: 1,
        x: -70,
        y: 0
    });
    this.vsBadge.addComponent(this.bluPigBadge);
    this.progressPigRight = new ComponentPicture({
        image: s_ui_pig_green_scared,
        // width:112,
        // height:120,
        xScale: 0.6,
        yScale: 0.6,
        x: 125,
        y: -2
    });
    this.vsBadge.addComponent(this.progressPigRight);
    this.progressPigLeft = new ComponentPicture({
        image: s_ui_pig_green_default_main,
        // width:112,
        // height:120,
        xScale: -0.6,
        yScale: 0.6,
        x: -125,
        y: -2
    });
    this.vsBadge.addComponent(this.progressPigLeft);
    setTimeout(function () {
        // This is a hack to fix negative scaling not working initially
        _this.progressPigLeft.setScale(-0.6, 0.6);
    }, 1);
    var leftProfileScale = profileManager.scaler(profileManager.getInfo(tgfHooks.getPlayerID()).image, 64);
    this.leftAvatarImg = new ComponentPicture({
        image: profileManager.getInfo(tgfHooks.getPlayerID()).image,
        width: 64,
        height: 64,
        xScale: leftProfileScale,
        yScale: leftProfileScale,
        angle: -0.174533,
        x: -120,
        y: 0
    });
    this.backBarLeft.addComponent(this.leftAvatarImg);
    this.leftAvatar = new ComponentPicture({
        image: s_portrait_empty,
        width: 64,
        height: 64,
        xScale: 0.45,
        yScale: 0.45,
        angle: -0.174533,
        x: -120,
        y: 0
    });
    this.backBarLeft.addComponent(this.leftAvatar);
    this.playerRankBG = new ComponentPicture({
        image: ExpManager.getRankAssets().emblem,
        x: -30,
        y: 33,
        xScale: 0.25,
        yScale: 0.25
    });
    this.leftAvatar.addComponent(this.playerRankBG);
    this.playerRank = new ComponentLabel({
        text: ExpManager.getRank().toString(),
        font: {
            fontFace: angrybirds_regular_text.fontFace,
            fontSize: 18,
            fillColor: "#503d25",
            align: "center",
            textStyle: "italic",
            fontWeight: "bold",
            baseline: "middle"
        }
    });
    this.playerRankBG.addComponent(this.playerRank);
    var rightProfileScale = 0.4;
    this.rightAvatarImg = new ComponentPicture({
        image: s_profile_placeholder,
        width: 64,
        height: 64,
        xScale: rightProfileScale,
        yScale: rightProfileScale,
        angle: 0.174533,
        x: 120,
        y: 0
    });
    this.backBarRight.addComponent(this.rightAvatarImg);
    this.rightAvatar = new ComponentPicture({
        image: s_portrait_empty,
        width: 64,
        height: 64,
        xScale: 0.45,
        yScale: 0.45,
        angle: 0.174533,
        x: 120,
        y: 0
    });
    this.backBarRight.addComponent(this.rightAvatar);
    this.opponentRankBG = new ComponentPicture({
        image: s_rankbg,
        x: 30,
        y: 33,
        xScale: 0.25,
        yScale: 0.25
    });
    this.rightAvatar.addComponent(this.opponentRankBG);
    this.opponentRank = new ComponentLabel({
        text: ExpManager.getFriendRank("123").toString(),
        font: {
            fontFace: angrybirds_regular_text.fontFace,
            fontSize: 18,
            fillColor: "#503d25",
            align: "center",
            textStyle: "italic",
            fontWeight: "bold",
            baseline: "middle"
        }
    });
    this.opponentRankBG.addComponent(this.opponentRank);
    topFontPigCount.fontSize = 48;
    topFontPigCount.strokeColor = "#1e90c9";
    this.labelPigCountLeft = new ComponentLabel({
        text: this.countPigs(this.isInitiatingPlayer).toString(),
        font: topFontPigCount,
        align: "center",
        xScale: 0.8,
        yScale: 0.8,
        x: -5,
        y: -24
    });
    this.bluPigBadge.addComponent(this.labelPigCountLeft);
    topFontPigCount.fontSize = 22;
    topFontPigCount.fontSize = 48;
    topFontPigCount.strokeColor = "#db3455";
    this.labelPigCountRight = new ComponentLabel({
        text: this.countPigs(!this.isInitiatingPlayer).toString(),
        font: topFontPigCount,
        align: "center",
        xScale: 0.8,
        yScale: 0.8,
        x: -5,
        y: -24
    });
    this.redPigBadge.addComponent(this.labelPigCountRight);
    topFontPigCount.fontSize = 22;
    var P1_name = profileManager.getFirstName(tgfHooks.getPlayerID()).replace(/([\S\s]{11})(.*)/, "$1..");
    topFont.strokeColor = "black";
    topFont.align = "left";
    this.labelPlayerNameLeft = new ComponentLabel({
        text: P1_name,
        font: topFont,
        xScale: UI_SIZE_X,
        yScale: UI_SIZE_Y,
        x: -80,
        y: -14
    });
    this.backBarLeft.addComponent(this.labelPlayerNameLeft);
    topFont.strokeColor = "black";
    topFont.align = "right";
    this.labelPlayerNameRight = new ComponentLabel({
        text: tgfDictionary.getText('OPPONENT_TEXT'),
        font: topFont,
        xScale: UI_SIZE_X,
        yScale: UI_SIZE_Y,
        x: 80,
        y: -14
    });
    this.backBarRight.addComponent(this.labelPlayerNameRight);
    this.container.addComponent(this.vsBadge);
};
ScoreBarDialog.prototype.setPosition = function (x, y) {
    this.container.setPosition(x, y);
    this.x = this.container.x;
    this.y = this.container.y;
};
ScoreBarDialog.prototype.loadedOpponent = function (data, id) {
    "use strict";
    this.labelPlayerNameRight.setText(data.name.replace(/([\S\s]{11})(.*)/, "$1.."));
    if (this.rightAvatarImg) {
        var img = data.image ? data.image : s_profile_placeholder;
        this.rightAvatarImg.changeImage(img);
        var scale = profileManager.scaler(img, 64);
        this.rightAvatarImg.setScale(scale, scale);
        this.rightAvatar.changeImage(this.rightAvatar.image);
    }
    var rank;
    if (playController.gameType === "challenge") {
        rank = ExpManager.getFriendRank(id);
    }
    else {
        rank = AIController.getDisplayRank();
    }
    this.opponentRankBG.changeImage(ExpManager.getRankAssets(rank).emblem);
    this.opponentRank.setText(rank.toString());
    this.opponentRank.bringToFront();
};
ScoreBarDialog.prototype.setPigScore = function (leftScore, rightScore) {
    this.labelPigCountLeft.setText(leftScore.toString());
    this.labelPigCountRight.setText(rightScore.toString());
};
